"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _types = require("../types");

var getButtonStyles = function getButtonStyles(disabled, type, c) {
  if (disabled) return "\n            color: ".concat(c.grey.c, ";\n            background-color: ").concat(c.grey.f, ";\n\n            border: none;\n\n            :hover,\n            :focus {\n                color: ").concat(c.grey.c, ";\n            }\n        ");

  switch (type) {
    case _types.ButtonTypes.SECONDARY:
      return "\n                color: ".concat(c.white.a, ";\n                background-color: ").concat(c.grey.b, ";\n\n                :hover,\n                :focus {\n                    color: ").concat(c.white, ";\n                    background-color: ").concat(c.grey.c, ";\n                }\n            ");

    case _types.ButtonTypes.TERTIARY:
      return "\n                color: ".concat(c.black.a, ";\n                background-color: ").concat(c.grey.h, ";\n\n                :hover,\n                :focus {\n                    color: ").concat(c.black.a, ";\n                    background-color: ").concat(c.grey.g, ";\n                }\n          ");

    case _types.ButtonTypes.WHITE:
      return "\n                color: ".concat(c.black.a, ";\n                background-color: ").concat(c.white.a, ";\n\n                :hover,\n                :focus {\n                    color: ").concat(c.black.a, ";\n                }\n            ");

    case _types.ButtonTypes.PRODUCT:
      return "\n                color: ".concat(c.white.a, ";\n                background-color: ").concat(c.blue.a, ";\n\n                :hover,\n                :focus {\n                    color: ").concat(c.white.a, ";\n                    background-color: ").concat(c.blue.b, ";\n                }\n            ");

    default:
      return "\n                color: ".concat(c.white.a, ";\n                background-color: ").concat(c.black.a, ";\n\n                :hover,\n                :focus {\n                    color: ").concat(c.white.a, ";\n                    background-color: ").concat(c.black.b, ";\n                }\n\n                :active {\n                    color: ").concat(c.white.a, ";\n                }\n            ");
  }
};

var _default = getButtonStyles;
exports.default = _default;